"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Button = ({ color = "primary", variant = "contained", size = "medium", icon, children, onPress, disabled, active, fullWidth }) => {
    // const buttonVariant = !color || color === 'default' ? '' : `btn-${color}`;
    const buttonVariant = (0, react_1.useMemo)(() => {
        const variantText = variant === "contained" ? "" : "outline-";
        return `btn-${variantText}${color}`;
    }, [variant, color]);
    const sizeClass = size === "small" ? "btn-sm" :
        size === "large" ? "btn-lg" : "";
    return ((0, jsx_runtime_1.jsxs)("button", { className: `position-relative btn ${buttonVariant} fw-bold ${active ? 'active' : ''}${fullWidth ? " w-100" : ""} ${sizeClass}`, onClick: onPress, type: "button", disabled: disabled, children: [icon ? (0, jsx_runtime_1.jsxs)("span", { className: size === "small" ? "pe-0" : "pe-2", children: [icon, " "] }) : null, children] }));
};
exports.Button = Button;
